import { ethers } from "ethers";

export function getRpcProvider(chain = "ethereum") {
  const RPCS = {
    ethereum: `https://eth-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_KEY}`,
    polygon: "https://polygon-rpc.com",
    arbitrum: "https://arb1.arbitrum.io/rpc",
  };

  return new ethers.JsonRpcProvider(RPCS[chain]);
}
